import React from "react"

import globalStyles from "../../../../App.module.scss";
import totp from './images/totp.png'
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function TotpGenerator() {

    let data = `import base64
import hashlib
import hmac
import struct
import sys
import time


def generate_totp(secret: str, digits: int = 6, interval: int = 30, timestamp: float = None) -> str:
    timestamp = time.time() if timestamp is None else timestamp
    counter = int(timestamp // interval)

    padded_secret = secret.upper() + "=" * ((8 - len(secret) % 8) % 8)
    key = base64.b32decode(padded_secret)
    counter_bytes = struct.pack(">Q", counter)

    hmac_digest = hmac.new(key, counter_bytes, hashlib.sha1).digest()

    # Dynamic truncation (RFC 4226 section 5.3): pick 4 bytes starting at
    # the offset given by the low nibble of the digest's last byte.
    offset = hmac_digest[-1] & 0x0F
    truncated = struct.unpack(">I", hmac_digest[offset:offset + 4])[0] & 0x7FFFFFFF

    code = truncated % (10 ** digits)
    return str(code).zfill(digits)


def seconds_remaining(interval: int = 30) -> int:
    return interval - int(time.time()) % interval


if __name__ == "__main__":
    if len(sys.argv) != 2:
        print("Usage: python totp.py <base32-secret>")
        sys.exit(1)

    shared_secret = sys.argv[1]
    while True:
        code = generate_totp(shared_secret)
        remaining = seconds_remaining()
        print(f"\\r{code}  (refreshes in {remaining:2d}s)", end="", flush=True)
        time.sleep(1)
`

    return (
        <div className={globalStyles.article}>
            <h1>TOTP generator</h1>
            <p>A from-scratch implementation of the Time-based One-Time Password algorithm (RFC 6238) — the same
                algorithm apps like Google Authenticator or Authy use for 2FA codes. Uses only the standard library:
                an HMAC-SHA1 of the current 30-second time window, truncated down to a 6-digit code.</p>
            <p>Point it at any base32 TOTP secret (the same one you'd feed into an authenticator app when scanning a
                QR code) and it prints a live-refreshing code in the terminal.</p>
            <div style={{maxWidth: '800px'}}>
                <SyntaxHighlighter
                    children={data}
                    style={dracula}
                    PreTag="div"
                    language={'python'}
                />
            </div>
            <p>The program above produces the next output:</p>
            <div style={{maxWidth: '335px'}}>
                <img src={totp} alt={""}/>
            </div>
        </div>
    )
}
